import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Target, Trophy } from 'lucide-react';

/**
 * Segmented mode toggle between Quick Match (/) and Tournament (/tournament).
 * Use at the top of either page to let users switch freely.
 */
export function ModeToggle() {
  const location = useLocation();
  const navigate = useNavigate();
  const isTournament = location.pathname.startsWith('/tournament');
  const isQuick = location.pathname === '/play' || location.pathname === '/';

  return (
    <div
      className="inline-flex rounded-full bg-muted/60 border border-border p-1 mx-auto"
      data-testid="mode-toggle"
    >
      <button
        onClick={() => navigate('/play')}
        className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide transition-all ${
          isQuick
            ? 'bg-primary text-primary-foreground shadow'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        data-testid="mode-toggle-quick"
      >
        <Target className="h-3.5 w-3.5" /> Quick Match
      </button>
      <button
        onClick={() => navigate('/tournaments')}
        className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide transition-all ${
          isTournament
            ? 'bg-secondary text-secondary-foreground shadow'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        data-testid="mode-toggle-tournament"
      >
        <Trophy className="h-3.5 w-3.5" /> Tournament
      </button>
    </div>
  );
}

export default ModeToggle;
